var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hlqFoot"},[_c('div',{staticClass:"footer"},[_c('span',[_vm._v("主管部门:濮阳市农业农村局")]),_c('span',[_vm._v("监管部门:濮阳市纪委监委")]),_c('span',[_vm._v("管理单位:濮阳市农村集体\"三资\"服务办公室")]),_c('span',[_vm._v("技术单位:河南晟宇信息技术有限公司")])])])
}]

export { render, staticRenderFns }